const teacherDashboardUrl = '/teacher-dashboard/';

export default teacherDashboardUrl;
